import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { putCookie, useQuery, useCheckBox } from '@chilecompra/react-kit'
import { CheckBox, CheckBoxSkeleton, Typography } from '@chilecompra/react-kit/components'

import ProtectByFeatures from '../../components/Security/ProtectByFeatures'
import { updateQuery } from '../../modules/utils/searches'
import { SEARCHS_KEYS_DICTIONARY, QUOTE_SEARCH_FILTER_INITIAL_PAGE } from '../../config/settings/constants'
import routes from '../../config/settings/routes'
import { Accordion, AccordionDetails, AccordionSummary, ExpandMoreIcon } from './QuoteSearchFilters.styles'

/*
 * The Search Other Filters' component
 */
const OtherFilters = props => {
  const { forcePriorized, isBuyer, isLoading, isNoEMT, isSeller, handleSearchActionThunk } = props

  const navigate = useNavigate()
  const query = useQuery()

  const { value: checkboxMyBidQuotesValue, onChange: handleCheckboxMyBidQuotesChange } = useCheckBox({
    changeCallback: updatedValue => {
      handleCheckChange(SEARCHS_KEYS_DICTIONARY.MY_BID, updatedValue)
    },
    initialValue: query.has(SEARCHS_KEYS_DICTIONARY.MY_BID) ? query.get(SEARCHS_KEYS_DICTIONARY.MY_BID) === '1' : false
  })
  const { value: checkboxMyAreasQuotesValue, onChange: handleCheckboxMyAreasQuotesChange } = useCheckBox({
    changeCallback: updatedValue => {
      handleCheckChange(SEARCHS_KEYS_DICTIONARY.MY_AREAS, updatedValue)
    },
    initialValue: query.has(SEARCHS_KEYS_DICTIONARY.MY_AREAS)
      ? query.get(SEARCHS_KEYS_DICTIONARY.MY_AREAS) === '1'
      : false
  })
  const {
    onChange: handleCheckboxMyPriorizedQuotesChange,
    setValue: setCheckboxMyPriorizedQuotesValue,
    value: checkboxMyPriorizedQuotesValue
  } = useCheckBox({
    changeCallback: updatedValue => {
      handleCheckChange(SEARCHS_KEYS_DICTIONARY.PRIORIZED, updatedValue)
    },
    initialValue: query.has(SEARCHS_KEYS_DICTIONARY.PRIORIZED)
      ? query.get(SEARCHS_KEYS_DICTIONARY.PRIORIZED) === '1'
      : false
  })
  const { value: checkboxMyQuotesToCloseValue, onChange: handleCheckboxMyQuotesToClosesChange } = useCheckBox({
    changeCallback: updatedValue => {
      handleCheckChange(SEARCHS_KEYS_DICTIONARY.QUOTE_CLOSED, updatedValue)
    },
    initialValue: query.has(SEARCHS_KEYS_DICTIONARY.QUOTE_CLOSED)
      ? query.get(SEARCHS_KEYS_DICTIONARY.QUOTE_CLOSED) === '1'
      : false
  })
  const { value: checkboxPurchaseStatusValue, onChange: handleCheckboxPurchaseStatusChange } = useCheckBox({
    changeCallback: updatedValue => {
      handleCheckChange(SEARCHS_KEYS_DICTIONARY.PURCHASE_STATUS, updatedValue)
    },
    initialValue: query.has(SEARCHS_KEYS_DICTIONARY.PURCHASE_STATUS)
      ? query.get(SEARCHS_KEYS_DICTIONARY.PURCHASE_STATUS) === '1'
      : false
  })

  const handleCheckChange = (key, checked) => {
    let dictionary = {
      ...Object.fromEntries(query.entries()),
      page: QUOTE_SEARCH_FILTER_INITIAL_PAGE
    }

    if (checked) {
      dictionary = {
        ...dictionary,
        [key]: '1'
      }
    } else {
      dictionary[key] && delete dictionary[key]
      query.has(key) && query.delete(key)
    }

    updateQuery(query, dictionary)
    putCookie('search', query.toString())
    navigate({ pathname: routes.search, search: query.toString() }, { replace: true })
    handleSearchActionThunk(query)
  }

  const renderSellerFilters = () => (
    <>
      {isLoading ? (
        <>
          <CheckBoxSkeleton rows="3" />
          <CheckBoxSkeleton rows="3" />
        </>
      ) : (
        <>
          <CheckBox
            label="Ver solamente cotizaciones que he ofertado"
            checked={checkboxMyBidQuotesValue}
            onChange={handleCheckboxMyBidQuotesChange}
          />
          <CheckBox
            label="Ver solamente Compras Ágiles de mis rubros"
            checked={checkboxMyAreasQuotesValue}
            onChange={handleCheckboxMyAreasQuotesChange}
          />
        </>
      )}

      {isNoEMT &&
        (isLoading ? (
          <CheckBoxSkeleton rows="3" />
        ) : (
          <CheckBox
            label="Ver solamente Compras Ágiles en las que puedo participar"
            checked={checkboxMyPriorizedQuotesValue}
            onChange={handleCheckboxMyPriorizedQuotesChange}
          />
        ))}
    </>
  )

  const renderBuyerFilters = () =>
    isLoading ? (
      <>
        <CheckBoxSkeleton rows="3" />
        <CheckBoxSkeleton rows="3" />
      </>
    ) : (
      <>
        <CheckBox
          checked={checkboxMyQuotesToCloseValue}
          label="Cerradas que serán canceladas automáticamente en los próximos 5 días."
          margin="0 0 13px"
          onChange={handleCheckboxMyQuotesToClosesChange}
        />
        <ProtectByFeatures rule={features => features['feature.show.purchase.order.filter']}>
          <CheckBox
            checked={checkboxPurchaseStatusValue}
            label="Compras ágiles con Orden de Compra Cancelada o Eliminada."
            margin="0 0 13px"
            onChange={handleCheckboxPurchaseStatusChange}
          />
        </ProtectByFeatures>
      </>
    )

  useEffect(() => {
    if (isNoEMT && forcePriorized) {
      setCheckboxMyPriorizedQuotesValue(isNoEMT)
    }
  }, [isNoEMT])

  return (
    <Accordion defaultExpanded elevation={0}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content">
        <Typography variant="h4" fontWeight="bold">
          {isBuyer && 'Otros filtros'}
          {isSeller && 'Cotizaciones'}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {isSeller && renderSellerFilters()}
        {isBuyer && renderBuyerFilters()}
      </AccordionDetails>
    </Accordion>
  )
}
OtherFilters.propTypes = {
  isBuyer: PropTypes.bool,
  isSeller: PropTypes.bool,
  isLoading: PropTypes.bool,
  isNoEMT: PropTypes.bool,
  forcePriorized: PropTypes.bool,
  handleSearchActionThunk: PropTypes.func
}

export default OtherFilters
